if (window.innerWidth <= 768) {
    const accordionItemsUsp = document.querySelectorAll('.hoox-usp__item');

    if (accordionItemsUsp && accordionItemsUsp.length) {
        accordionItemsUsp.forEach(accordion => {
            const accordionBtnUsp = accordion.querySelector('.hoox-usp__accordion-header');
            const panelUsp = accordion.querySelector('.hoox-usp__repeater-text');
            accordionBtnUsp.addEventListener('click', () => {
                accordion.classList.toggle('show-text');
                panelUsp.style.maxHeight = panelUsp.scrollHeight + 'px';
                !accordion.classList.contains('show-text') ? panelUsp.style.maxHeight = null : panelUsp.style.maxHeight = panelUsp.scrollHeight + 40 + 'px';
            });
        })
    }
}